import { useState, useEffect } from 'react';

export default function Sorting({ v, onChange, showAnswers, student_answer }) {
 
  const shuffleArray = (arr) => {
    const result = [...arr];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  const [items, setItems] = useState(shuffleArray(v?.answers));
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', index);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Allow drop
  };

  const handleDrop = (index) => {
    if (draggedIndex === null || draggedIndex === index) return;
    const newItems = [...items];
    const draggedItem = newItems[draggedIndex];
    newItems.splice(draggedIndex, 1);
    newItems.splice(index, 0, draggedItem);
    setItems(newItems);

    let joinAns = v?.answers?.join("");
    let joinMy = newItems?.join("");
    
    let right = false;
    if (joinAns == joinMy) {
      right = true;
    }

    onChange({ ID: v?.ID, answers: newItems, right: right });
    setDraggedIndex(null);
  };

  useEffect(() => {
    if (student_answer) {
      setItems(student_answer);
    } else {
      if (showAnswers) {
          setItems(v?.answers);
      } else {
          setItems(shuffleArray(v?.answers));
      }
    }
    
  }, [showAnswers])
  

  return (
    <>
      {items.map((item, index) => (
        <label
            key={index}
            draggable={student_answer ? false : true}
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            onDrop={() => handleDrop(index)}
            style={{
                cursor: 'grab',
            }}
        >
        {item}
        </label>
      ))}
    </>
  );
}
